import { render, staticRenderFns } from "./shopzc.vue?vue&type=template&id=25197bd9&"
import script from "./shopzc.vue?vue&type=script&lang=js&"
export * from "./shopzc.vue?vue&type=script&lang=js&"
import style0 from "./shopzc.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports